import styled from 'styled-components';

export const WhyPartnerInfoBlock = styled.div(
  props => `
        width: ${props.timeZone ? '100%' : '58%'};
        display: flex;
        flex-direction: column;
        margin-left: 20px;

        @media(max-width:1023px){
            width:100%;
        }
    `,
);

export const WhyPartnerHeadWrap = styled.div(
  props => `
        display: flex;
        flex-direction: column;
        text-align: ${props.timeZone ? 'center' : 'start'};
        
        @media(max-width:1023px){
            display: none;
        }
    `,
);

export const WhyPartnerHeadText = styled.h2(
  props => `
        font-size:3.6rem;
        color: #2f281e;
        font-weight: 900;
    `,
);

export const WhyPartnerSubText = styled.p(
  props => `
        font-size: 1.8rem;
        color: #333333;
        padding-top:0.5rem;
    `,
);

export const WhyPartnerInfoTileWrap = styled.div(
  props => `
        display: flex;
        flex-direction: ${props?.timeZone ? 'row' : 'column'};
        justify-content: ${props?.timeZone ? 'center' : ''};
        @media(max-width:1023px){
            flex-direction: ${props?.timeZone ? 'column' : 'column'};
            margin-top: 40px;
        }
    `,
);

export const WhyPartnerInfoInnerWrap = styled.div(
  props => `

        display: flex;
        align-items: center;
        margin-top: 5rem;
        flex-direction: ${props?.timeZone ? 'column' : ''};
        min-height: ${props?.timeZone ? '150px' : ''};
        justify-content: ${props?.timeZone ? 'space-between' : ''};
        @media(max-width:1023px){
            flex-direction: column;
            margin-top:0;
            justify-content: ${props?.timeZone ? 'center' : ''};
            min-height: ${props?.timeZone ? '0px' : ''};
        }
    `,
);

export const WhyPartnerInfoTile = styled.div(
  props => `
        display: flex;
        align-items: ${props.timeZone ? 'flex-start' : 'center'};
        width: ${props.timeZone ? '100%' : '50%'};
        @media(max-width:1023px){
            width:100%;
            margin-top:2rem;
        }
    `,
);

export const WhyPartnerIconWrap = styled.div(
  props => `
        width:3.6rem;
        height:3.6rem;
    `,
);

export const WhyPartnerInfoTextWrap = styled.div(
  props => `
        display: flex;
        flex-direction: column;
        padding-left:1.5rem;
        width:85%;
    `,
);

export const WhyPartnerInfoHeadText = styled.h4(
  props => `
        font-size: 1.6rem
        color: #3f4561;
        text-transform: uppercase;

        @media(max-width:1023px){
            font-size: 1.4rem;
            font-weight: 900;
        }
    `,
);

export const WhyPartnerInfoSubText = styled.p(
  props => `
        font-size: 1.6rem;
        color: #4a4a4a;
        @media(max-width:1023px){
            font-size: 1.4rem;
        }
    `,
);
